<template>
  <dara-single-content-layout container-size="lg">
    <template v-if="user" #content>
      <div v-if="user.id">
        <dara-header size="lg">{{ $t('editing-user') }} {{ user.name }}</dara-header>
        <dara-user-edit-information @save="save" />
      </div>
      <div v-if="!user_id">
        <dara-header size="lg">{{ $t('add-user') }}</dara-header>
        <dara-user-create-information :existing-users-email="existingUsersEmail" :total-users="totalUsers" @create="save" @import="importUsers" />
      </div>
    </template>
  </dara-single-content-layout>
</template>

<script>
import { toastError, toastSuccess } from '@/services/toastService';
import { formatDate, formatToTimeAgo } from '@/helpers/date';
import { goToOpenUser, goToUserForbiddenPage } from '@/modules/user/user.routes';
import { getters } from '@/modules/user/user.store';
import { getUserById, updateUserInformation, createNewUser, importUsers } from '@/modules/user/user.service';
import { USERS_ROLES } from '@/modules/user/user.constants';
import { translate } from '@/services/translate.service';

import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';
import DaraUserEditInformation from '@/modules/user/components/UserEditComponent.vue';
import DaraUserCreateInformation from '@/modules/user/components/UserCreateComponent.vue';

export default {
  name: 'DaraUserEditPage',
  components: {
    DaraSingleContentLayout,
    DaraUserEditInformation,
    DaraUserCreateInformation,
  },
  provide() {
    const userEditVm = {};
    Object.defineProperty(userEditVm, 'user', {
      get: () => this.user,
    });
    return { userEditVm };
  },
  data() {
    return {
      existingUsersEmail: [],
      totalUsers: 0,
      currentUser: getters.getUser(),
      user: null,
    };
  },
  computed: {
    user_id() {
      return this.$route.params?.id;
    },
  },
  mounted() {
    if (this.user_id) {
      if (this.currentUser.permission < USERS_ROLES.ADMIN) goToUserForbiddenPage(this.$router, false);
      this.onFetch();
    } else {
      if (this.currentUser.permission < USERS_ROLES.ADMIN) goToUserForbiddenPage(this.$router, true);
      this.onFetch();
    }
  },
  methods: {
    onFetch() {
      if (this.user_id) {
        getUserById(this.user_id)
          .then(data => {
            this.user = data;
          })
          .catch(() => toastError(`${translate('error-on-getting-user-by-id')}`));
      } else {
        this.user = {
          name: '',
          last_name: '',
          email: '',
          position: '',
          permission: '0',
        };
      }
    },
    save() {
      if (this.user_id) {
        updateUserInformation(this.user)
          .then(() => {
            toastSuccess(`${translate('user-successfully-saved')}`);
          })
          .catch(() => toastError(`${translate('error-updating-users-profile')}`));
      } else {
        if (!this.user.department_id) {
          toastError(`${translate('you-need-to-specify-the-user-department')}`);
          return;
        }
        createNewUser(this.user)
          .then(data => {
            goToOpenUser(this.$router, data);
          })
          .catch(() => toastError(`${translate('error-creating-new-user')}`));
      }
    },
    importUsers(csvFile, department) {
      if (!department) {
        toastError(`${translate('you-need-to-specify-the-department-of-the-imported-users')}`);
        return;
      }
      importUsers(csvFile, department.id)
        .then(users => {
          this.existingUsersEmail = [];
          users.data.forEach(user => {
            if (user.exists) {
              this.existingUsersEmail.push(user.email);
            }
          });
          this.totalUsers = users.data.length;
          if (this.existingUsersEmail.length > 0) {
            toastError(`${translate('some-emails-already-registered')}`);
          } else {
            toastSuccess(`${translate('users-successfully-imported')}`);
          }
        })
        .catch(err => {
          if (err.toString().includes('NO_PERMISSION')) {
            toastError(`${translate('cant-add-user-with-permission-three')}`);
          } else if (err.toString().includes('FILE_INCORRECT')) {
            toastError(`${translate('file-with-incorrect-model-data')}`);
          } else if (err.toString().includes('MISSING_INFORMATION')) {
            toastError(`${translate('file-with-missing-information')}`);
          } else if (err.response.data.message === 'PERMISSION_DENIED') {
            toastError(`${translate('you-dont-have-the-right-permission')}`);
          } else if (err.response.data.errors === 'USER_WITHOUT_DEPARTMENT') {
            toastError(`${translate('error-on-importing-user-with-no-department')}`);
          } else {
            toastError(`${translate('error-on-importing-users')}`);
          }
        });
    },
    formatDate,
    formatToTimeAgo,
  },
};
</script>
